import { Show } from 'solid-js'

const SubscriptionModal = (props: { show: boolean; onClose: () => void; redirectURL?: string }) => {
  return (
    <Show when={props.show}>
      <div class="fixed inset-0 z-[200] flex items-center justify-center bg-black/80">
        <div class="relative mx-2 w-full max-w-[560px] rounded-xl bg-gradient-to-r from-cosplay-purple to-cosplay-blue-200 p-[2px] md:mx-4">
          <div class="relative h-full w-full overflow-hidden rounded-lg bg-[#0B0F11]">
            <button
              onClick={props.onClose}
              class="absolute right-5 top-4 z-10 text-2xl text-white hover:text-white md:right-6 md:top-6 md:text-gray-400"
            >
              ✕
            </button>
            <div class="h-[880px] max-h-[calc(100vh-140px)] w-full p-3 md:p-6">
              <iframe
                src={props.redirectURL}
                class="h-full w-full"
                style="border: 0;"
                allow="payment"
              />
            </div>
          </div>
        </div>
      </div>
    </Show>
  )
}

export default SubscriptionModal
